/**
 * humanTextureLibrary.js — FASE R6 micro-humanization phrase bank.
 *
 * Pure data. No logic. Consumed by other R6 modules as exemplar primers
 * and as pattern classifiers for anti-formula detection.
 *
 * These phrases are NOT injected verbatim into every response.
 * They represent the register — the feel — Kevia should inhabit.
 */

// ── Phrase banks by type ────────────────────────────────────────────

export const TEXTURE_PHRASES = {
  // Very short openers — presence before analysis
  reflective_openings: [
    "Mm…",
    "Sí…",
    "Entiendo.",
    "Qué difícil.",
    "Claro.",
    "Vaya.",
    "Uf.",
    "Sí, entiendo.",
  ],

  // Single-sentence empathy without elaboration
  understated_empathy: [
    "Eso pesa.",
    "No es poco.",
    "Tiene sentido que duela.",
    "Eso es mucho.",
    "No te queda fácil.",
    "Qué carga.",
    "Eso duele.",
    "Entiendo por qué cansa.",
    "Eso cambia mucho las cosas.",
  ],

  // Soft connective tissue — not transitions, just breath
  transitional_breath: [
    "Y supongo que…",
    "A veces,",
    "Quizá,",
    "Honestamente,",
    "Y también…",
    "Aunque…",
    "Supongo que",
  ],

  // Open pastoral questions — not coaching questions
  soft_questions: [
    "¿Cómo lo llevas tú?",
    "¿Y cómo estás tú con todo esto?",
    "¿Qué necesitas ahora mismo?",
  ],

  // Minimal affirmations — presence without commentary
  restrained_affirmations: [
    "Aquí estoy.",
    "Sí.",
    "Claro.",
    "Te escucho.",
  ],

  // Understatement closers — resist completing everything
  understatement_phrases: [
    "Tal vez no tienes que resolverlo todo hoy.",
    "Puedes no saber la respuesta.",
    "No tienes que tener todo claro ahora.",
    "A veces estar presente es suficiente.",
    "No hay que apurarse.",
  ],
};

// ── Pattern classifiers ─────────────────────────────────────────────
// Used by pastoralCadenceVariation to identify structural shapes.

export const OPENER_PATTERNS = {
  breath: [
    /^(mm|sí\.\.\.|uf|vaya|claro[,.]|entiendo[,.])\s/i,
    /^(mm…|sí…)/i,
  ],
  empathy: [
    /^(eso (pesa|duele|cansa|es mucho)|qué (difícil|carga)|no es poco|cuánto|no te queda)/i,
    /^(tiene sentido|entiendo por qué)/i,
  ],
  affirmation: [
    /^(aquí estoy|te escucho|te acompaño|sí,\s|claro,\s|te veo)/i,
  ],
  question: [
    /^¿/,
    /^(sabes|cómo|qué necesitas)/i,
  ],
  prayer: [
    /^(señor|padre|dios|señor,)/i,
  ],
  statement: [],  // fallback — catches everything else
};

export const CLOSER_PATTERNS = {
  question: [
    /\?\s*$/,
  ],
  open: [
    /(sigo aquí|estoy aquí|te acompaño|lo que necesites|cuando quieras)\.\s*$/i,
  ],
  hopeful: [
    /(no estás solo|dios te acompaña|con fe|hay esperanza|él está contigo)\.\s*$/i,
  ],
  understate: [
    /(…|\.\.\.)$/,
    /(no tienes que|no hay que|puedes no|tal vez hoy no)\.\s*$/i,
  ],
  complete: [],   // fallback — declarative sentence end
};
